import { css } from '@emotion/react';
import { useStore } from 'hooks/useStore';
import { useObserver } from 'mobx-react-lite';
import React from 'react';

import { ButtonStyle } from 'styles/ButtonStyle';
import { themeOld } from 'styles/theme';
import { MessagePanel } from './MessagePanel';

export const Errors = () => {
	const { errorStore, networkStatus } = useStore();

	return useObserver(() => (
		<MessagePanel
			active={(errorStore.errors.length > 0 || errorStore?.serverError) && networkStatus.online}
		>
			{!errorStore?.serverError &&
				errorStore?.errors.map(({ type, message }, index) => {
					return (
						<div key={index}>
							<strong
								css={css`
									font-weight: 600;
								`}
							>
								{type}{' '}
							</strong>
							{message}
						</div>
					);
				})}

			{!!errorStore && errorStore.serverError && (
				<div>
					{' '}
					<span
						css={css`
							font-weight: 600;
						`}
					>
						Uups, something is wrong :(
					</span>{' '}
					Bad on our side, please try it later or
					<button
						css={[
							ButtonStyle({ sizeSmall: true }),
							css`
								margin-left: 12px;
								display: inline-flex;
								height: 32px;
								color: ${themeOld.COLOR_BASE_RED};
								border: 0;
								&:hover,
								&:focus {
									background: rgba(255, 255, 255, 0.8);
									border: 0;
									color: ${themeOld.COLOR_BASE_RED};
								}
								&:active {
									background: rgba(255, 255, 255, 0.5);
									border: 0;
									color: ${themeOld.COLOR_BASE_RED};
								}
							`,
						]}
						onClick={() => {
							window.location.reload();
						}}
					>
						Refresh Page
					</button>
				</div>
			)}
		</MessagePanel>
	));
};
